import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 21,
    width: 21,
    margin: theme.spacing(0.5),
    marginBottom: 0,
    opacity: 0.3
  }
}));

interface Props {
  disabled?: boolean;
  message: string;
  style?: React.CSSProperties;
};

const HelpTooltip = ({disabled = false, message, style = {}}: Props) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
  <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip 
        title={message}
        className={classes.root}
        disableFocusListener={disabled}
        disableHoverListener={disabled}
        disableTouchListener={disabled}
        style={style}
        onClose={handleTooltipClose}
        open={open}
      >
        <HelpIcon onClick={handleTooltipOpen} />
      </Tooltip>
  </ClickAwayListener>
  );
};

export default HelpTooltip;
